const DicoButton = (props: any) => {
  const { id, params, clickDico, children } = props;

  // if (definition && definition.length > 0)
  return (
    <button
      type="button"
      className="rd-dico-btn"
      title="Voir la définition"
      style={{
        color: params?.color || "white",
        fontFamily: params?.isDYS ? "OpenDyslexic-Regular" : "Poppins-Regular",
        fontSize: params?.fontSize || 16,
      }}
      onClick={() => {
        clickDico(id);
      }}
    >
      {children}
    </button>
  );
  // else return <>{children}</>;
};

export default DicoButton;
